import { useState } from "react";
import { useDispatch } from "react-redux";

import FormInput from "../form-input/form-input.component";
import Button from "../button/button.component";
import {SignUpContainer} from './sign-up-form.styles.jsx'
import { signUpStart } from "../../store/user/user.action";

const defaultFormFields = {
    displayName: '',
    email: '',
    password: '',
    confirmPassword: '',
}

const SignUpForm = () => {
    const [formFields, setFormFields] = useState(defaultFormFields);
    const { displayName, email, password, confirmPassword } = formFields;
    const dispatch = useDispatch();

    const resetFormFields = () => {
        setFormFields(defaultFormFields);
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        // confirm password matches password
        if(password !== confirmPassword){ 
            alert("Passwords do not match");
            return;
        }

        try {
            dispatch(signUpStart(email, password, displayName))
            resetFormFields();
        
        } catch (error) {
            if (error.code === 'auth/email-already-in-use'){
                alert('Cannot create user, email already in use');
            } else {
            console.log('user creation encountered an error', error)
        }
      }
    };

    const handleChange = (event) =>{
        const { name, value } = event.target;
        
        setFormFields({...formFields, [name]: value });
    };

    return (
        <SignUpContainer>
            <h2>Don't Have an account?</h2>
            <span>Sign up with email and password</span>
            <form onSubmit={handleSubmit}>
                <FormInput
                    label="Display Name" 
                    type="text" 
                    required 
                    onChange={handleChange} 
                    name="displayName" 
                    value={displayName}
                />
                
                <FormInput 
                    label="Email"
                    type="email" 
                    required 
                    onChange={handleChange} 
                    name="email" 
                    value={email}
                />

                <FormInput 
                    label="Password"
                    type="password" 
                    required 
                    onChange={handleChange} 
                    name="password" 
                    value={password} 
                />

                <FormInput 
                    label="Confirm Password"
                    type="password" 
                    required
                    onChange={handleChange}
                    name="confirmPassword" 
                    value={confirmPassword}
                />
                <Button type="submit">Sign Up</Button>
            </form>
        </SignUpContainer>
    );
};

export default SignUpForm;